import React, { useState, useEffect } from "react";
import Pagination from "react-js-pagination";
import NhanVayApi from "service/nhanVayApi";
import { formatNumber } from "utils/currencyFormat";
import { getDate } from "utils/formatDate";

export const LichSuTraBotGoc = ({ hopdong, nhanvayId }) => {
  const dataInit = {
    List: [],
    TongSoTien: 0,
  };
  const [dataLichSuTraBotGoc, UpdateDataLichSuTraBotGoc] = useState(dataInit);
  const DanhSachVayThemTraBotGoc = () => {
    NhanVayApi.getLichSuTraBotGocNhanVay(nhanvayId).then((response) => {
      UpdateDataLichSuTraBotGoc({
        ...dataLichSuTraBotGoc,
        List: response.data.List,
        TongSoTien: response.data.TongSoTien,
      });
    });
  };

  useEffect(() => {
    DanhSachVayThemTraBotGoc();
  }, []);

  const listItem = () => {
    return (
      dataLichSuTraBotGoc.List != null &&
      dataLichSuTraBotGoc.List.map((item, index) => {
        return (
          <>
            <tr className="">
              <td>{index + 1}</td>
              <td className="">{getDate(item.NgayTraGoc)}</td>
              <td className="text-right">{formatNumber(item.SoTien)}</td>
              <td className="text-left">{item.GhiChu}</td>
            </tr>
          </>
        );
      })
    );
  };
  return (
    <div className="table-from-detailtl1">
      <div className="Left808x200  Table-main-morman table-noboder-new">
        <div className="table-responsive table-new1">
          <table className="table table-bordered table-hover">
            <thead>
              <tr>
                <th className="w-stt">STT</th>
                <th className="w-10">Ngày trả gốc</th>
                <th className="text-right w-20">
                  Số tiền
                  <br />  
                  <span className="red">
                    {formatNumber(dataLichSuTraBotGoc.TongSoTien)}
                  </span>
                </th>
                <th className="text-left">Ghi chú</th>
              </tr>
            </thead>
            <tbody>{listItem()}</tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
